module.exports = "pegasus/assets/blocks/column-4-theme4.png";